import { render, staticRenderFns } from "./Hiring.vue?vue&type=template&id=f640dd4e"
import script from "./Hiring.vue?vue&type=script&lang=js"
export * from "./Hiring.vue?vue&type=script&lang=js"
import style0 from "./Hiring.vue?vue&type=style&index=0&id=f640dd4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports